import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Tabs
import ScheduleGradeTrainingEditTab from './Elements/ScheduleGradeTrainingEditTab';
import ScheduleGradeTrainingVacationsTab from './Elements/ScheduleGradeTrainingVacationsTab';
import ScheduleGradeInitialsTab from './Elements/ScheduleGradeInitialsTab';
import ScheduleGradeTrainingTrainingsTab from './Elements/ScheduleGradeTrainingTrainingsTab';
import AddCheckbox from './Elements/AddCheckbox';
import getLocale from '../../i18n/getLocale';
class ScheduleGradesTrainings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      schedule_grade: {},
      schedule: {},
      aircraft_model: {},
      grade: {},
      grade_alternate: {},
      grade: {},
      grade_extra_main: {},
      aircrafts_available: {},
      staffs_list: null,
      aircrafts_remaining: {},
      bases: {},
      aircrafts_list: {},
      bases_active_list: {},
      schedule_days: {},
      types_list: [],
      initials_colors: {},
      initials: {},
      schedule_grade_initials: {},
      chiefs: {},
      remaining_staffs: {},
      remaining_staffs_list: {},
      modal_alert: false,
      alerts: {},
      modal_add_staff: false,
      staffs_elegible: {},
      checkbox_marked_ids: [],
      checkbox_marked_data: [],
      errors_listing: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.viewAlerts = this.viewAlerts.bind(this);
    this.closeModalAlert = this.closeModalAlert.bind(this);
    this.viewAlertsPdf = this.viewAlertsPdf.bind(this);
    
    
    this.updateDataEditMode = this.updateDataEditMode.bind(this);
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.resetGrade = this.resetGrade.bind(this);
    this.saveGrade = this.saveGrade.bind(this);
    this.openAddModal = this.openAddModal.bind(this);
    this.closeModalStaff = this.closeModalStaff.bind(this);

    this.AddCheckbox = this.AddCheckbox.bind(this);
    this.unmarkAllCheckbox = this.unmarkAllCheckbox.bind(this);
    this.markAllCheckbox = this.markAllCheckbox.bind(this);
    this.markedCheckboxId = this.markedCheckboxId.bind(this);
    this.UnmarkCheckboxId = this.UnmarkCheckboxId.bind(this);
    this.add = this.add.bind(this);

    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    
    this.locale = getLocale();
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  // Fecha modal
  closeModalAlert(event){
    this.setState({modal_alert: false, alerts: {}});
  }

  // Fecha modal
  closeModalStaff(event){
    this.setState({modal_add_staff: false, alerts: {}});
  }

  onRowSelect(row, isSelected, e) {
    let checkbox_marked_ids = this.state.checkbox_marked_ids;
    let checkbox_marked_data = this.state.checkbox_marked_data;
    if (isSelected) {
      checkbox_marked_ids.push(row.id);
      checkbox_marked_data.push(row.staff_id);
    } else {
      for (let i = 0; i < checkbox_marked_ids.length; i++) {
        if(checkbox_marked_ids[i] === row.id) {
          checkbox_marked_ids.splice(i, 1);
        }
      }
      for (let i = 0; i < checkbox_marked_data.length; i++) {
        if(checkbox_marked_data[i] === row.staff_id) {
          checkbox_marked_data.splice(i, 1);
        }
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids, checkbox_marked_data: checkbox_marked_data});
  }
  

  onSelectAll(isSelected, rows) {
    let checkbox_marked_ids = [];
    let checkbox_marked_data = [];
    if (isSelected) {
      for (let i = 0; i < rows.length; i++) {
        checkbox_marked_ids.push(rows[i].id);
      }
      for (let i = 0; i < rows.length; i++) {
        checkbox_marked_data.push(rows[i].staff_id);
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids, checkbox_marked_data: checkbox_marked_data});
  }


  // gero os dados do modal de alertas da grade
  viewAlerts (schedule_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/escala/treinamentos/' + schedule_id + '/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }

  // gero os dados do modal de alertas da grade
  openAddModal (event) {
    event.preventDefault();
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/treinamento/tripulantes/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staffs_elegible: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_add_staff: true});
      })
    });
  }

  updateData (responseJson) {
    this.setState({updated: 1, show_select: 0}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var aircraft_model_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/info/treinamentos/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas');
        if (responseJson.data.schedule_grade) {
          aircraft_model_id = responseJson.data.schedule_grade.schedule.aircraft_model_id;
          self.setState({schedule_grade: responseJson.data.schedule_grade});
          self.setState({schedule: responseJson.data.schedule_grade.schedule});
          self.setState({schedule_grade_initials: responseJson.data.schedule_grade_initials.data});
        }
        if (responseJson.status === 'success') {
          self.setState({trainings: responseJson.data.trainings});
          self.setState({trainings_eligible: responseJson.data.trainings_eligible});
          self.setState({aircraft_model: responseJson.data.schedule_grade.schedule.aircraft_model});
          self.setState({remaining_staffs_list: responseJson.data.remaining_staffs_list.data});
          self.setState({schedule_days: responseJson.data.schedule_days});
          self.setState({grade_schedule_trainings: responseJson.data.grade_schedule_trainings});
          self.setState({schedule_vacations: responseJson.data.schedule_vacations});
          self.setState({types_list: responseJson.data.types_list.data});
          self.setState({initials_colors: responseJson.data.initials_colors.data});
          self.setState({initials: responseJson.data.initials.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  viewAlertsPdf(schedule_grade_id) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/pdf/escala-grade/alertas/treinamentos/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get('cdn') + '/tmp/' + responseJson.data);
      })
    });
  }


  updateDataEditMode (grade) {
    this.setState({updated: 1, show_select: 0, grade_schedule_trainings: [...grade.grade_schedule_trainings]});
    this.setState({overlay: {message: '', type: '', status: 'closed'}});
  }

  resetGrade () {
    if(window.confirm(this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.descartarAlteracoes)) {
      this.setState({overlay: {message: '', type: '', status: 'open'}});
      this.toggleEditMode();
      this.updateData();
    }
  }

  saveGrade () {
    var self = this;
    if(window.confirm(this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.salvarAlteracoes)) {
      this.handleAlert('', '', 'open');
      var datasave = {
        grade: this.state.grade,
        grade_schedule_trainings: this.state.grade_schedule_trainings,
        id: self.props.match.params.id,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/edicao/treinamento/salvar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.toggleEditMode();
            self.updateData(responseJson);
          } else {
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Toggle de modo de edição
  toggleEditMode(){
    if (this.state.edit_mode) {
      this.setState({edit_mode: false});
    } else {
      this.setState({edit_mode: true});
    }
  }

  AddCheckbox (cell, row) {
    var botao = (
      <div>
        <AddCheckbox handleAlert={this.handleAlert} markedCheckboxId={this.markedCheckboxId} UnmarkCheckboxId={this.UnmarkCheckboxId} checkbox_marked_ids={this.state.checkbox_marked_ids} id={cell} staff_data={row} />
      </div>
    );

    return botao;
  }

  unmarkAllCheckbox () {
    this.setState({checkbox_marked_ids: [], checkbox_marked_data: []});
  }

  markAllCheckbox () {
    var self = this;
    var ids_temp = [];
    var data_temp = [];
    Object.keys(self.state.checkbox_marked_data).map(function(k) {
      ids_temp.push(self.state.checkbox_marked_data[k].id);
      data_temp.push(self.state.checkbox_marked_data[k]);
    });
    self.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  markedCheckboxId (value) {
    var ids_temp = this.state.checkbox_marked_ids;
    var data_temp = this.state.checkbox_marked_data;
    ids_temp.push(value.id);
    data_temp.push(value);
    this.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  UnmarkCheckboxId (value) {
    var self = this;
    var ids_temp = [];
    var data_temp = [];
    var checkbox_ids = this.state.checkbox_marked_ids;
    checkbox_ids.map(function(checked_id) {
      if(checked_id !== value.id) {
        ids_temp.push(checked_id);
        data_temp.push(value);
      }
    });
    self.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      checkbox_marked_ids: this.state.checkbox_marked_ids,
      checkbox_marked_data: this.state.checkbox_marked_data,
      schedule_grade_id: this.props.match.params.id,
      schedule_id: this.state.schedule.id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/adicionar/treinamentos/tripulantes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: true,
            modal_add_staff: false,
            errors_messages: responseJson.data,
          });
          self.handleAlert('', '', 'closed');
        } else {
          self.setState({
            errors_listing: false,
            modal_add_staff: false,
            errors_messages: [],
            checkbox_marked_ids: [],
            checkbox_marked_data: [],
          });
          self.updateData(responseJson);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={self.handleLoaded} />
  <Overlay overlay={self.state.overlay} handleAlert={self.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.titulo} - {self.state.aircraft_model.model} - {self.state.schedule.name}</h3>
      <Link to={"/escala/treinamentos/editar/" + self.state.schedule.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="btn-group button-inline pull-right">
        <button onClick={() => { self.viewAlerts(self.state.schedule.id) }} className="btn btn-warning"><i className="fa fa-warning"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.botaoExibirAlertas}</button>
        <button className="btn btn-warning button-inline" onClick={() => { self.viewAlertsPdf(self.props.match.params.id) }}><i className="fa fa-fw fa-file-pdf-o"></i></button>
      </div>
      <div className="btn-group button-inline pull-right">
        <button onClick={self.openAddModal} className="btn btn-success"><i className="fa fa-user-plus"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.botaoInclusaoAutomatica}</button>
      </div>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.erros}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <hr/>
      <Tabs activeKey={self.state.key} onSelect={self.handleNavTab.bind(self, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabEscala.tituloTab}>
          <ScheduleGradeTrainingEditTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} grade_schedule_trainings={self.state.grade_schedule_trainings} remaining_staffs_list={self.state.remaining_staffs_list} schedule_used_regime_list={self.state.schedule_used_regime_list} schedule_used_regimes={self.state.schedule_used_regimes} schedule_days={self.state.schedule_days} types_list={self.state.schedule_grade_initials} initials_colors={self.state.initials_colors}  edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} updateDataEditMode={self.updateDataEditMode} staffs_by_id={self.state.staffs_by_id} resetGrade={self.resetGrade} saveGrade={self.saveGrade}  />
        </Tab>
        <Tab eventKey={2} title={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabFerias.tituloTab}>
          <ScheduleGradeTrainingVacationsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} schedule_vacations={self.state.schedule_vacations} remaining_staffs_list={self.state.remaining_staffs_list} schedule_days={self.state.schedule_days} types_list={self.state.schedule_grade_initials} initials_colors={self.state.initials_colors}   />
        </Tab>
        <Tab eventKey={3} title={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabSiglas.tituloTab}>
          <ScheduleGradeInitialsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} initials={self.state.initials} />
        </Tab>
        <Tab eventKey={4} title={this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabTreinamentos.tituloTab}>
          <ScheduleGradeTrainingTrainingsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} trainings_eligible={self.state.trainings_eligible} trainings={self.state.trainings} />
        </Tab>
      </Tabs>
    </div>
  </div>
  <Modal show={self.state.modal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tituloRevisao} {self.state.schedule_grade.revision} - {self.state.aircraft_model.model} - {self.state.schedule.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.global_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.global_alerts).map(function(k) {
          var alert = self.state.alerts.global_alerts[k];
          if (alert.status === 'danger') {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
        <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-1 text-center">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelarRevisao.Nome}</th>
            <th className="col-md-8 text-center">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelarRevisao.Alerta}</th>
          </tr>
        </thead>
        {Object.keys(self.state.alerts.personal_alerts).map(function(nickname) {
          var alerts = self.state.alerts.personal_alerts[nickname];
          return(
            <tbody id="suppliers-certifications">
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger' && (alert.official === 1 || alert.exception === 1)) {
                  return(
                    <tr>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{nickname}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}><div dangerouslySetInnerHTML={{__html: alert.message}}></div></td>
                    </tr>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
            </tbody>
          );
        })}
        </table>
      </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  
  <Modal show={self.state.modal_add_staff} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h3 className="pull-left">{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tituloSelecioneOsTripulantesParaAdicionarAEscala}</h3>
      <div className="btn-group button-inline pull-right">
        <button className="btn btn-danger btn-sm" onClick={self.closeModalStaff}>
        <i className="fa fa-fw fa-close"></i></button>
      </div>
      <div className="clearfix"></div>
      <hr/>      
    </Modal.Header>
    <Modal.Body>
      <BootstrapTable data={self.state.staffs_elegible} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelaAdicionarTripulantes.semTreinamentos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar} selectRow={ {
        mode: 'checkbox',
        clickToSelect: true,
        onSelect: this.onRowSelect,
        onSelectAll: this.onSelectAll
      } }  >
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelaAdicionarTripulantes.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelaAdicionarTripulantes.Tripulante}</TableHeaderColumn>
        <TableHeaderColumn dataField="training_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelaAdicionarTripulantes.Treinamento}</TableHeaderColumn>
        <TableHeaderColumn dataField="certification_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelaAdicionarTripulantes.Certificado}</TableHeaderColumn>
        <TableHeaderColumn dataField="training_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelaAdicionarTripulantes.Codigo}</TableHeaderColumn>
        <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.tabelaAdicionarTripulantes.Periodo}</TableHeaderColumn>
      </BootstrapTable>
      <button onClick={self.add} className="btn btn-success btn-block"><i className="fa fa-sign-in"></i> {this.locale.GradesDeEscala.GradesDeEscalaDeTreinamento.botaoIncluirColaboradores}</button>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalStaff}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleGradesTrainings;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/ScheduleGradesTrainings.js